export default __webpack_public_path__ + "static/media/mistral-serveurs.2b3ebe97.jpg";